import api from '@/lib/axios';

export const satCatalogService = {
  async findProducts(search?: string) {
    const response = await api.get('/sat/products', { params: { search } });
    return response.data;
  },

  async findProductByCode(code: string) {
    const response = await api.get(`/sat/products/${code}`);
    return response.data;
  },

  async findUnits(search?: string) {
    const response = await api.get('/sat/units', { params: { search } });
    return response.data;
  },

  async findUnitByCode(code: string) {
    const response = await api.get(`/sat/units/${code}`);
    return response.data;
  },

  async findTaxRegimes() {
    const response = await api.get('/sat/tax-regimes');
    return response.data;
  },
};
